import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { Image } from "lucide-react";
import { ImageUploadField } from "./ImageUploadField";

export const BrandingSection = ({ settings, onInputChange, onFileUpload }) => (
  <Card>
    <CardHeader>
      <CardTitle className="flex items-center gap-2">
        <Image className="w-5 h-5" />
        Images & Branding
      </CardTitle>
    </CardHeader>
    <CardContent className="space-y-6">
      <ImageUploadField label="Logo (Fond clair)" field="logo_light" currentValue={settings.logo_light} onInputChange={onInputChange} onFileUpload={onFileUpload} />
      <Separator />
      <ImageUploadField label="Logo (Fond sombre)" field="logo_dark" currentValue={settings.logo_dark} onInputChange={onInputChange} onFileUpload={onFileUpload} />
      <Separator />
      <ImageUploadField label="Favicon" field="favicon" currentValue={settings.favicon} onInputChange={onInputChange} onFileUpload={onFileUpload} />
      <Separator />
      <ImageUploadField label="Image Open Graph (Reseaux sociaux)" field="og_image" currentValue={settings.og_image} onInputChange={onInputChange} onFileUpload={onFileUpload} />
      <div className="bg-muted/50 rounded-lg p-4 text-sm text-muted-foreground">
        <p className="font-medium mb-2">Recommandations :</p>
        <ul className="list-disc list-inside space-y-1">
          <li>Logo : PNG transparent, 200x60px minimum</li>
          <li>Favicon : ICO ou PNG, 32x32px ou 64x64px</li>
          <li>Open Graph : JPG ou PNG, 1200x630px</li>
        </ul>
      </div>
    </CardContent>
  </Card>
);
